module.exports = __webpack_public_path__ + "images/2-i_olddc575b0c0c4fc3d7360cd63934691b21.svg";